import { Select } from "@chakra-ui/react";
import { AlertsContext } from "providers/alerts";
import { useTenant } from "modules/tenant/providers/tenant-provider";
import { useState, useContext } from "react";
import { apiRequest } from "utils/api";
import { getErrorMessage } from "utils/errorHandler";
import { isPermissionEnabled, permissionConstants, hasPermission } from "utils/permissionHelper";

const RoleSelect = ({
  member,
  roles,
  onLoad,
  isDisabled: externalDisabled = false,
}: {
  member: any;
  roles: any[] | undefined;
  onLoad: () => void;
  isDisabled?: boolean;
}) => {
  const { showSuccess, showError } = useContext(AlertsContext);
  const { user } = useTenant();
  const [loading, setLoading] = useState(false);

  const checkPermission = () => {
    if (
      !hasPermission(user, permissionConstants.editUserRolesPermissions) &&
      isPermissionEnabled(user)
    ) {
      return true;
    }
    return false;
  };

  const updateMemberRole = async (id: string, role: string) => {
    try {
      setLoading(true);
      await apiRequest("/supabase/users/update", {
        id,
        values: {
          role,
        },
      });
      onLoad();
      showSuccess({
        title: "Role Updated",
        description: "The member role has been successfully updated.",
      });
    } catch (error) {
      showError({
        title: "Update Failed",
        description: getErrorMessage(error),
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Select
      isDisabled={loading || checkPermission() || externalDisabled}
      value={member.role.id}
      size="sm"
      onChange={ev => updateMemberRole(member.id, ev.target.value)}
    >
      {roles?.map(role => (
        <option key={role.id} value={role.id}>
          {role.displayName}
        </option>
      ))}
    </Select>
  );
};

export default RoleSelect;
